var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMecoLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 328,
    height: 328,
    viewBox: "0 0 328 328",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.013 77.8138C205.985 77.7806 205.955 77.7474 205.926 77.7143C205.896 77.6811 205.866 77.648 205.837 77.6149L205.271 76.9757C189.884 59.6161 163.586 58.2405 146.532 73.9033C146.407 74.0179 146.283 74.1332 146.16 74.249C146.042 74.355 145.924 74.4619 145.807 74.5696L86.0519 129.45C68.5976 145.481 67.2145 172.88 82.9631 190.647C98.7106 208.414 125.627 209.823 143.081 193.792L172.683 166.604L239.532 242.024C254.919 259.384 281.217 260.759 298.271 245.097C315.324 229.434 316.675 202.664 301.289 185.304L206.013 77.8138Z",
    fill: "url(#paint0_linear_198_584)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.916 241.691C12.235 223.918 13.6122 196.509 30.9921 180.472L84.1027 131.467C84.5763 131.031 85.0572 130.606 85.544 130.196C85.8393 129.906 86.1397 129.62 86.4452 129.338C102.54 114.487 127.359 115.792 141.881 132.251L143.919 134.56L143.965 134.613L144.011 134.666L168.188 162.068C169.609 163.68 170.88 165.377 172 167.141L114.447 220.246L114.437 220.238L87.7783 244.837C70.3981 260.873 43.597 259.465 27.916 241.691Z",
    fill: "#462EC3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.8393 185.124C65.4788 162.648 73.0445 140.068 89.8686 125.874C89.375 126.29 90.3487 125.431 89.8686 125.874C89.5588 126.161 90.1679 125.58 89.8686 125.874C95.8065 119.88 107.683 116.883 119.559 118.382C131.435 119.881 144.231 133.685 144.231 133.685L144.277 133.739L144.325 133.793L173 166.331C171.516 167.829 159.64 178.318 141.826 194.8C124.012 211.283 92.1997 207.6 78.8393 185.124Z",
    fill: "#FF8469"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M170 197C151.775 197 137 211.998 137 230.5C137 249.002 151.775 264 170 264C188.225 264 203 249.002 203 230.5C203 211.998 188.225 197 170 197Z",
    fill: "#FF8469"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_198_584",
    x1: 145.441,
    y1: 173.292,
    x2: 335.103,
    y2: 168.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD6A1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC86E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMecoLogo);
export default __webpack_public_path__ + "static/media/meco-logo.266baba06746a106205116c09749d678.svg";
export { ForwardRef as ReactComponent };